import React, {useState} from "react";
import FormPreviewModal from "./FormPreviewModal";
import FeedbackModal from "./FeedbackModal";
import {apiRequest} from "../api";

const FormList = ({forms, onEdit, onDuplicate}) => {
    const [previewForm, setPreviewForm] = useState(null); // Form to preview
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const universityId = localStorage.getItem("universityId");
    const handleDuplicate = async (form) => {
    const duplicatedForm = {
        ...form,
        name: `${form.name} (Copy)`,
        id: undefined, // Ensure it's treated as a new form
        last_updated: new Date().toISOString(),
        is_default: false, // Ensure the duplicated form is not default
    };

    const token = localStorage.getItem("token"); // Retrieve the token from local storage
    const url = `${apiUrl}/form/`; // Set the endpoint

    try {
        await apiRequest(url, "POST", duplicatedForm, token); // Use apiRequest to send the POST request
        setFeedbackMessage("Form duplicated successfully!");
        if (onDuplicate) onDuplicate(); // Trigger a refresh in parent
    } catch (error) {
        console.error("Error duplicating form:", error);
        setFeedbackMessage("Failed to duplicate form. Please try again.");
    }
};

    return (
        <div className="table-responsive">
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Form Name</th>
                    <th>Type</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {forms.map((form) => (
                    <tr key={form.id}>
                        <td>{form.name}</td>
                        <td>{form.type}</td>
                        <td>{new Date(form.last_updated).toLocaleDateString()}</td>
                        <td>
                            {form.is_default ? (
                                <span></span>
                            ) : (
                                <>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => onEdit(form)}
                                    >
                                        Edit
                                    </button>

                                </>
                            )}
                            <button
                                className="btn btn-secondary btn-sm ml-2"
                                onClick={() => setPreviewForm(form)}
                            >
                                Preview
                            </button>
                            <button
                                className="btn btn-success btn-sm ml-2"
                                onClick={() => handleDuplicate(form)}
                            >
                                Duplicate
                            </button>
                        </td>

                    </tr>
                ))}
                </tbody>
            </table>
            {previewForm && (
                <FormPreviewModal
                    fields={Object.entries(previewForm.fields).map(([name, details]) => ({
                        name,
                        ...details,
                    }))}
                    onClose={() => setPreviewForm(null)}
                />
            )}
            {feedbackMessage && (
                <FeedbackModal
                    message={feedbackMessage}
                    onClose={() => setFeedbackMessage(null)}
                />
            )}
        </div>
    );
};

export default FormList;